export default "__VITE_ASSET__DNqPplXp__"